import React from "react";
import * as c from "./awards.module.scss";
import classNames from "classnames";
import { graphql, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const Awards = ({ className }) => {
  const data = useStaticQuery(graphql`
    query {
      badges: allFile(
        filter: { extension: { regex: "/(jpg)|(jpeg)|(png)/" }, relativeDirectory: { eq: "review-badges/redesign" } }
        sort: { name: ASC }
      ) {
        nodes {
          image: childImageSharp {
            gatsbyImageData(height: 110, quality: 90, placeholder: NONE, layout: CONSTRAINED)
          }
          name
        }
      }
    }
  `);

  return (
    <div className={classNames(c.container, className)} data-transition="slide-stagger-child">
      <>
        {data.badges.nodes.map(({ image, name }) => (
          <GatsbyImage
            key={name}
            className={c.badge}
            image={getImage(image)}
            imgStyle={{
              objectFit: "contain",
              objectPosition: "center center",
            }}
            alt=""
          />
        ))}
      </>
    </div>
  );
};

export { Awards };
